import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';

import styles from './AdditionalFun.module.scss';

export default class AdditionalFun extends React.Component {
  onClickAdditionalFun = () => {
    const { additionalFun = {}, onClickAdditionalFunFunc } = this.props;
    onClickAdditionalFunFunc(additionalFun);
  };

  onDragAdditionalFunStart = (e) => {
    const { additionalFun = {} } = this.props;
    const { index = -1 } = additionalFun;
    e.dataTransfer.setData('text/plain', index);

    e.stopPropagation();
  };

  onDragAdditionalFunOver = (e) => {
    const { additionalFun = {}, highlightDestinationFunc } = this.props;
    const { index = -1 } = additionalFun;
    e.preventDefault();
    e.stopPropagation(); // Don't send it further
    highlightDestinationFunc(index);
  };

  // TODO: Test drag\drop as it has a slight change.
  onDropAdditionalFun = (e) => {
    const { additionalFun = {}, onSwapFunc } = this.props;
    const { index = -1 } = additionalFun;
    const from = e.dataTransfer.getData('text');
    const to = index;
    onSwapFunc(from, to);

    e.stopPropagation();
  };

  render() {
    const { additionalFun = {}, highlight = -1 } = this.props;
    const { name = '', text = '' } = additionalFun;
    if (isEmpty(additionalFun)) return <div />;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let paddingRight,
      paddingBottom = '0px';

    if (highlight === additionalFun.index) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      paddingRight = '18px';
      paddingBottom = '8px';
    }
    return (
      <div
        style={{
          borderColor,
          borderStyle,
          paddingRight,
          paddingBottom,
        }}
      >
        <ListItem
          className={styles.root}
          onClick={this.onClickAdditionalFun}
          draggable
          onDragStart={this.onDragAdditionalFunStart}
          onDragOver={this.onDragAdditionalFunOver}
          onDrop={this.onDropAdditionalFun}
        >
          <div className={styles.additionalFun}>
            <div className={styles.extraLargeColumn}>{name}</div>
            <div className={styles.extraLargeColumn}>{text}</div>
            <div className={styles.extraLargeColumn} />
          </div>
        </ListItem>
      </div>
    );
  }
}
